import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextField, Grid, Avatar } from '@mui/material';
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as FlightImageActions from '../../redux/actions/flightImageAction';

const AddFlightImage = ({ mode }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const stateData = location?.state?.stateData;
    const dispatch = useDispatch();

    const [inputFieldDetail, setInputFieldDetail] = useState({ airlineName: stateData ? stateData?.airlineName : '', airlineCode: stateData ? stateData?.airlineCode : '' });
    const [inputFieldError, setInputFieldError] = useState({ airlineName: '', airlineCode: '' });
    const [image, setImage] = useState({ file: stateData ? stateData?.airlineImage : logo_icon, bytes: "" });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setInputFieldDetail({ ...inputFieldDetail, [name]: value });
    };

    //* Handle Image
    const handleImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage({
                file: URL.createObjectURL(e.target.files[0]),
                bytes: e.target.files[0],
            });
        }

        handleInputFieldError("image", null)
    };

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;
        const { airlineName, airlineCode } = inputFieldDetail;
        const { file } = image;

        if (!airlineName) {
            handleInputFieldError("airlineName", "Please Enter Airline Name")
            isValid = false;
        }
        if (!airlineCode) {
            handleInputFieldError("airlineCode", "Please Enter Airline Code")
            isValid = false;
        }
        if (!file) {
            handleInputFieldError("image", "Please Select Image")
            isValid = false;
        }

        return isValid;
    };

    //! Handle Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setInputFieldError({ airlineName: '', airlineCode: '' })
            console.log("Input Data :: ", { ...inputFieldDetail, image })
            const { airlineName, airlineCode } = inputFieldDetail;

            if (stateData) {
                let formData = new FormData()
                formData.append('airlineId', stateData?._id);
                formData.append('airlineName', airlineName);
                formData.append('airlineCode', airlineCode);
                formData.append('images', image?.bytes);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/flight-images")
                }

                //! Dispatching API for Updating
                dispatch(FlightImageActions.updateFlightImages(payload));

            } else {
                let formData = new FormData()
                formData.append('airlineName', airlineName);
                formData.append('airlineCode', airlineCode);
                formData.append('images', image?.bytes);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/flight-images")
                }

                //! Dispatching API for Creating
                dispatch(FlightImageActions.createFlightImages(payload));
            }
        }
    };

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Flight Image</div>
                    <div onClick={() => navigate("/flight-images")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
                </div>

                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Airline Name" variant='outlined' fullWidth
                            name='airlineName'
                            disabled={stateData && Object.keys(stateData).length > 0}
                            value={inputFieldDetail?.airlineName}
                            onChange={handleInputField}
                            error={inputFieldError.airlineName ? true : false}
                            helperText={inputFieldError.airlineName}
                            onFocus={() => handleInputFieldError("airlineName", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Airline Code" variant='outlined' fullWidth
                            name='airlineCode'
                            disabled={stateData && Object.keys(stateData).length > 0}
                            value={inputFieldDetail?.airlineCode}
                            onChange={handleInputField}
                            error={inputFieldError.airlineCode ? true : false}
                            helperText={inputFieldError.airlineCode}
                            onFocus={() => handleInputFieldError("airlineCode", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                            <Grid item xs={2} >
                                <Avatar src={image.file} style={{ width: 40, height: 40 }} />
                            </Grid>
                            <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                                Upload Image
                                <input onChange={handleImage} hidden accept="image/*" type="file" />
                            </Grid>
                        </Grid>
                        {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div >
        </>
    )
}

export default AddFlightImage